import { Layout } from 'antd';
import NavBar from "../../components/NavBar";
import TransferRobotDetail from "../../components/robot/TransferRobotDetail";

const { Content } = Layout;

function TransferRobot({ match }) {
   return (
      <Layout className="container main-layout">
         <NavBar />
         <Layout className="bg-gray">
            <Content className="layout-content">
               <TransferRobotDetail />
            </Content>
         </Layout>
      </Layout>
   );
}

export default TransferRobot;
